// extracted by mini-css-extract-plugin
export default {"ripple_button":"RippleButton_ripple_button__NeD-T","ripple":"RippleButton_ripple__gF0Pg","ripple-effect":"RippleButton_ripple-effect__LAjsL","content":"RippleButton_content__qkydX"};